import { render } from "./SubmissionSteps.vue?vue&type=template&id=6a793bda&scoped=true"
import script from "./SubmissionSteps.vue?vue&type=script&lang=js"
export * from "./SubmissionSteps.vue?vue&type=script&lang=js"

import "./SubmissionSteps.vue?vue&type=style&index=0&id=6a793bda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a793bda"]])

export default __exports__